<template>
  <div class="intro">
    <div class="top">
      <img :src="$apiBaseUrl+ top" style="width: 100%;height: 450px">
    </div>

    <div class="con_data des">
      <h1 class="blue bt">公司简介</h1>
      <div class="con">
        <div class="text">
          <p>
            河北八友台智能科技有限公司是一家以研发销售在线监测类产品及运行检修管理类软件为主的科技型中小企业，公司位于河北省石家庄市。自创立以来一直致力于为客户打造 “绿色”（节能降耗）的生产工艺以及“环保”（安全效率）的生产环境。公司的“设备物联智能化平台”通过设备在线监测系统，设备智能巡检系统，生产设备管理系统，智能语音通信融合系统，帮助客户更好的改进生产工艺，提高工作效率，争取更大的经济利益。也为公司管理层提供更好，更科学的管理依据。
          </p>
          <p>
            公司与国内外众多知名品牌企业建立了良好、稳固的合作伙伴关系，在国家电网、企业工厂、超市商场、住宅小区、学校、医院、酒店宾馆、智能大厦、机关事业单位等方面取得了优良成绩并先后取得了ISO9001质量管理体系认证、软件著作权、实用新型及发明专利。
          </p>
          <p>
           河北八友台智能科技有限公司坚持以“诚信、创新、沟通”为企业宗旨，以“技术、服务”为立业之本的团队精神，不断加强企业的内部管理，提高企业的综合竞争力，并形成一套
            完整的设计、安装、调试、培训、维护一站式服务体系。从而为您提供先进的技术及完整的售后服务。
          </p>
        </div>
        <div><img :src="img_1" style="width:550px;height:450px "></div>
      </div>
    </div>

    <div class="con_data team">
      <h1 class="blue center"><a name="aaa">研发团队</a></h1>
      <div class="text">GR是一款集资源管理、流程管理、网络管理、运营管理分析等领域集大成产品，在业界领先成熟产品线，也提供在机测量技术和虚拟加工技术，为客户提供可靠的定制化解决方案，帮助企业建立领先优势。
        科技聚焦产业互联网</div>
      <div class="team_img">
        <img :src="item" v-for="(item,index) in img_2" :key="index" style="width: 580px;height: 323px">

      </div>
    </div>

    <div class="con_data proof">
      <h1 class="blue center">资质证书</h1>
      <div class="text center">16年行业经验，拥有完善的工业体系及产品研发能力</div>
        <swiper  ref="mySwiper"
                 :options="swiperOption"
                 class="swiper-content swiper-container">
          <swiper-slide class="store-right-item" v-for="(item,index) in win" :key="index">
            <img :src="$apiBaseUrl+item.ImgPath">
          </swiper-slide>
        </swiper>
    </div>


  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
require('swiper/dist/css/swiper.css')

export default {
  name: "index",
  components:{
    swiperSlide,
    swiper
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: '6',
        spaceBetween: 0,
        speed: 4000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        }
      },
      win:[],
      top:'',
      img_1:require('../../assets/26.jpg'),
      img_2:[require('../../assets/24.png'),require('../../assets/25.png')]
    }

  },
  mounted() {
    this.getImage()
    this.getTop()
  },
  methods:{
    //获取荣誉证书
    getImage(){
      let data={params:{ImgCate:3}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.win = res.data;
      })
    },
    //获取top 图片
    getTop(){
      let data={params:{ImgCate:5}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
  }
}
</script>

<style scoped>
.bt{
  text-align: center ;
  padding: 50px 0;
}
.con{
  display: flex;
  justify-content: left;
}
.text{
  padding:20px 50px 0 0;
  text-indent: 30px;
  line-height: 25px;
  color: #555;
  margin-bottom: 50px;
}
.team{
  margin: 90px auto;
}
.team_img{
  display: flex;
  justify-content: space-between;
}
.proof{
  margin: 90px auto;
}
.swiper-content{
  height: 240px;
}
</style>